import { render } from "./surveyExpired.vue?vue&type=template&id=c2a13094&scoped=true"
import script from "./surveyExpired.vue?vue&type=script&lang=js"
export * from "./surveyExpired.vue?vue&type=script&lang=js"

import "./surveyExpired.vue?vue&type=style&index=0&id=c2a13094&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2a13094"

export default script